import momenttz from 'moment-timezone';
import { OrderNotificationLog } from '~types/orders/OrderNotificationLog';

const getOrderNotificationLogLabel = (notification: OrderNotificationLog) => {
  const timezone = momenttz.tz.guess();
  const dateString = momenttz
    .tz(notification.notifiedAt, timezone)
    .format('MM/DD/YY [at] hh:mma z');

  const language = notification.language?.language;
  const languageString = language
    ? `(${language.charAt(0).toUpperCase() + language.slice(1).toLowerCase()})`
    : '';

  return `${dateString} - ${notification.eventNameLabel} ${languageString}`;
};

export const formatOrderNotificationLogs = (notifications: OrderNotificationLog[]) => {
  return notifications
    .filter((notification) => !!notification.eventNameLabel)
    .map((notification) => ({
      id: notification.id,
      label: getOrderNotificationLogLabel(notification),
    }));
};
